import { dataMedicalKit } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMedicalKit = /*#__PURE__*/createIcon(dataMedicalKit)
export default IconMedicalKit
